export default typography => Object.keys(typography).reduce((acc, typographyName) => ({
  ...acc,
  [typographyName]: {
    type: `typography-type-${typographyName}`,
    default: `typography-default-${typographyName}`,
    lineheighted: `typography-lineheighted-${typographyName}`,
    colored: `typography-colored-${typographyName}`
  }
}), {});
//# sourceMappingURL=buildClasses.js.map